import { trustpilotGreen } from '@styles/theme';
import { themeVars } from '@styles/themes.css';
import { globalStyle, style } from '@vanilla-extract/css';

export const swiper = style({
  vars: {
    '--swiper-pagination-color': themeVars.brandColor.swiper.pagination.active,
    '--swiper-pagination-bullet-inactive-color':
      themeVars.brandColor.swiper.pagination.inactive,
    '--swiper-pagination-bullet-inactive-opacity': '1',
    '--swiper-pagination-bullet-size': '14px',
  },
  width: '100%',
});
globalStyle(`${swiper} .swiper-pagination`, {
  paddingTop: '0.625rem',
  top: 0,
  position: 'relative',
});
globalStyle(`${swiper} .swiper-wrapper`, { alignItems: 'center' });

export const slide = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.3125rem',
});

export const content = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.25rem',
  padding: '2rem 1.25rem',
  borderRadius: '0.625rem',
  background: '#fff',
});

export const title = style({
  fontFamily: themeVars.font.Magenos,
  fontWeight: 900,
});

export const rating = style({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
  justifyContent: 'space-around',
  alignItems: 'center',
  '@media': {
    'screen and (max-width: 64em)': { justifyContent: 'center' },
  },
});

export const name = style({
  color: trustpilotGreen,
  textAlign: 'center',
  fontSize: '0.75rem',
  fontFamily: themeVars.font.Roboto,
  whiteSpace: 'nowrap',
});

export const stars = style({
  margin: 'auto 0.5rem',
  color: trustpilotGreen,
  fontSize: '0.9375rem',
});
